import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Link } from "@heroui/react";
import { useParams } from "react-router-dom";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { A7OPCVMIssuersEditCard } from "./edit_card";

import { getIssuerAuditColumns } from "./columns";

const table_name = "a7_opcvm_issuers";

export const A7OPCVMIssuersEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getIssuerAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <A7OPCVMIssuersEditCard id={Number(id)} />
          </div>
          <div className="flex flex-col gap-2">
            <Button
              href={toWorkspacePath(
                `/admin/a7-opcvm/a7_opcvm_underlyings?issuer_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_opcvm_underlyings.title", {
                ns: "tables",
                defaultValue: "Financial instruments",
              })}
            </Button>
            <Button
              href={toWorkspacePath(
                `/admin/a7-opcvm/a7_opcvm_issuer_ts?issuer_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_opcvm_issuer_ts.title", {
                ns: "tables",
                defaultValue: "Issuer time series",
              })}
            </Button>
          </div>
        </div>
        <AuditCard
          audit_columns={auditColumns}
          client="a7"
          name={table_name}
          id={Number(id)}
        />
      </div>
    </div>
  );
};
